module.exports = __webpack_public_path__ + "media/images/icons/blogpost-1e5b925d536f2a27bc8b62f1349f737d.svg";